import { IconCheck } from "@tabler/icons-react"
import { IconNavion } from "@tfg/ui"
import { useMemo } from "react"

import { useGetOperations } from "~/utils/operations"

type Props = {
  progress: number
  activityName: string
  size?: number
  isTransferred?: boolean
}

export const ActivityProgressIcon = ({
  progress,
  activityName,
  size = 20,
  isTransferred = false,
}: Props) => {
  const operations = useGetOperations()
  const ActivityIconComponent = operations[activityName].icon

  const isCompleted = useMemo(() => {
    return progress === 100
  }, [progress])

  if (isTransferred) return <IconNavion size={size} color="blue" />

  if (isCompleted) return <IconCheck size={size} color="green" />
  if (ActivityIconComponent) return <ActivityIconComponent size={size} />
  return null
}
